import {Container} from "@material-ui/core";
import React from "react";
import Page from "../../components/Page";
import LogTable from "./LogTable";
import {HasRole} from "../../common/Util";
import {RoleIdEnum} from "../../generated/graphql";

export default () => {
    return (
        <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Finance, RoleIdEnum.Op, RoleIdEnum.Secretary]}>
        <Page title={"log page"}>
            <Container maxWidth={false} style={{ padding: "30px" }}>
                <LogTable />
            </Container>
        </Page>
        </HasRole>
    );
};
